import React, { type FC } from 'react';
import clsx from 'clsx';
import { FlexBox, Text, Button } from '@is24at/react-ui-core';
import styles from './RLEEntryPoint.scss';

const RLE_HREF_TARGET = '/lp/rle/maklerempfehlung-maklersuche.html';

type Props = {
  withNegativeMargin?: boolean;
};

const RLEEntryPoint: FC<Props> = ({ withNegativeMargin = true }) => {
  return (
    <FlexBox
      className={clsx(styles.container, {
        [styles.negative_margin]: withNegativeMargin,
      })}
      spacing={0}
    >
      <div className={styles.image} />
      <FlexBox
        className={styles.details}
        direction="column"
        alignItems="flex-start"
      >
        <Text color="gray-light" tag="h1" size="l">
          Erfolgreich verkaufen - mit Profi
        </Text>
        <Text color="gray-light">
          Wir empfehlen dir einen Makler aus der Region.
        </Text>
        <FlexBox className={styles.details__bottom_group} spacing={0}>
          <a
            className={styles.details__bottom_group__button}
            href={RLE_HREF_TARGET}
          >
            <Button className={styles.details__bottom_group__button}>
              Empfehlung erhalten
            </Button>
          </a>
          <div className={styles.details__bottom_group__logo} />
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};

export default RLEEntryPoint;
